import { IdLabel } from '@/types/transverse/details-types';

export type FormationsDetail = {
    id: number;
    titre: string;
    support?: Support;
    commentairesElearning?: string;
    synthese: Synthese;
    programmes?: Programme[];
    lienElearning?: boolean;
    type: IdLabel;
    ficheType?: IdLabel;
    sousTitre?: string;
    sessionReference?: string;
    cataloguePubliee: boolean;
    dureeMinutes: number;
    dureeJours: number;
    lieuNom?: string;
    organisateur: Organisateur;
    site?: Site;
    certifiant: boolean;
    mode?: IdLabel;
    dates: SessionDate[];
    catalogueUrl: string;
    catalogueReference: string;
    catalogueHash: string;
    dateDebut?: string;
    dateFin?: string;
    moduleElearning: ModuleElearning;
    formations?: Formation[];
    convocation: boolean;
    participantStatutId: number;
    testValidation: TestValidation;
    testPositionnement: TestPositionnement;
    sessionUrlParticipant: SessionUrlParticipant[];
    sessionUrlWebinaire: string;
    attestationId: number;
    fuseauHoraire?: string;
    produitLienElearning?: boolean;
    participantId?: string;
    examen?: Object;
};

export type Formation = {
    id: string;
    titre: string;
    datesFormations: string;
    lieu?: string;
    statutLabel: string;
    typeShortcut: string[];
    typeLabel: string[];
    dateDebut?: string;
    dateFin?: string;
    sessionStatut: IdLabel;
};
export type Support = {
    supports?: SupportItem[];
};

export type SessionUrlParticipant = {
    url?: string;
};

export type SupportItem = {
    id: number;
    titre: string;
    type: string;
    version: string;
    dateMiseAJour: string;
    dateDisponibilite: string;
};

export type SessionDate = {
    date: string;
    id: number;
    matin: boolean;
    aprem: boolean;
};

export type Organisateur = {
    email: string;
    telephone: string;
    nom: string;
};

export type Site = {
    id: number;
    denomination: string;
    numeroVoie: string;
    codePostal: string;
    ville: string;
    coordinates: string;
};

export type Prestation = {
    id: number;
    dureeMinutes?: number;
    heureDebut?: number;
    heureFin?: number;
    date?: string;
    nom?: string;
    titre?: string;
    veille?: boolean;
    site?: Site;
    type?: IdLabel;
    typeId?: number;
    lieuNom?: string;
};

export type PrestationELearning = {
    id: number;
    dureeMinutes: number;
    titre: string;
};

export type Programme = {
    prestations?: Prestation[] | PrestationELearning[];
    date?: string;
    titre?: string;
};

export type Synthese = {
    inscription: IdLabel;
    positionnement: IdLabel;
    validation: TestValidation;
    satisfaction: IdLabel;
    presence: IdLabel;
    statutElearning?: string;
    pif?: Pif;
};

export type ModuleElearning = {
    dateDebutAcces: string;
    dateFinAcces: string;
    dateDebutRetractation?: Date;
    dateFinRetractation?: Date;
    accessible: boolean;
    showRetractation: boolean;
    expire: false;
    statutString: string;
    statut: string;
    termine: boolean;
    cours: ModuleElearningCours[];
};

export type ModuleElearningCours = {
    titre: string;
    score: string;
    statutString: string;
    statut: string;
};

export type TestValidation = {
    id: number;
    label: string;
    nombreBonnesReponses: number;
    nbreQuestions: number;
    seuil: number;
    testIntermediaire?: boolean;
    nombreTentativesRestantes?: number;
};

export const TestPositionnementStatus = {
    NON_REQUIS: 1,
    REALISE: 2,
    A_REALISE: 3
};

export const TestValidationStatus = {
    NON_REQUIS: 1,
    NON_REALISE: 2,
    REALISE: 3,
    A_REALISE: 4,
    A_VENIR: 5
};

export const SatisfactionStatus = {
    NON_REQUIS: 1,
    NON_REALISE: 2,
    REALISE: 3,
    A_REALISE: 4,
    A_VENIR: 5
};

export type TestPositionnement = {
    produitId: number;
    repondu: boolean;
};

export type Pif = {
    id: number;
    disponible: boolean;
    signee: boolean;
    validee: boolean;
    label: string;
    produitTitre: string;
    elearningParticipantId: number;
};
